module.exports = __webpack_public_path__ + "assets/backgrid.93915223.svg";